import { Routes } from '@angular/router';
import { BatchesComponent } from './batches/batches.component';
import { ErrorpageComponent } from './errorpage/errorpage.component';
import { AdminComponent } from './admin/admin.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BatchComponent } from './batch/batch.component';
import { UserComponent } from './user/user.component';
import { LoginComponent } from './login/login.component';
import { unsavedChangesGuard } from './guards/unsaved-changes.guard';
import { unauthorizedGuard } from './guards/unauthorized.guard';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { AnimationComponent } from './animation/animation.component';
import { StoresComponent } from './stores/stores.component';
import { ScanmedicationComponent } from './scanmedication/scanmedication.component';
export const routes: Routes = [
    {
        path:"",
        component:AnimationComponent,
        canActivate:[unauthorizedGuard]
    },
    {
        path:"batch/:batchId",
        component:BatchesComponent,
        canActivate:[unauthorizedGuard],
        canDeactivate:[unsavedChangesGuard]
    },
    {
        path:"bad-request",
        component:ErrorpageComponent
    },
    {
        path:"admin",
        component:AdminComponent,
        canActivate:[unauthorizedGuard]
    },
    {
        path:"dashboard",
        component:DashboardComponent,
        canActivate:[unauthorizedGuard]
    },
    {
        path:"batchlist",
        component:BatchComponent,
        canActivate:[unauthorizedGuard]
    },
    {
        path:"user",
        component:UserComponent,
        canActivate:[unauthorizedGuard]
    },
    {
        path:"store",
        component:StoresComponent,
        canActivate:[unauthorizedGuard]
    },
    {
        path:"login",
        component:LoginComponent
    },{
        path:"unauthorized",
        component:UnauthorizedComponent
    },
    {
        path: '**',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    {
        path: 'scanmedication/:batchId',
        component: ScanmedicationComponent,
        canActivate: [unauthorizedGuard]
    }

]